import React, { useState, useRef } from "react";

interface HeroTooltipProps {
    content: React.ReactNode | string;
    children: React.ReactNode;
}

const HeroTooltip = ({ children, content }: HeroTooltipProps) => {
    const [isTooltipVisible, setTooltipVisible] = useState(false);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const tooltipOffsetX = 2;
    const tooltipOffsetY = -33;

    const containerRef = useRef<HTMLDivElement | null>(null);
    const tooltipRef = useRef<HTMLDivElement | null>(null);

    const handleMousePosition = (event: React.MouseEvent) => {
        const { clientX, clientY } = event;
        const containerTop = containerRef.current?.getBoundingClientRect().top;
        const containerLeft =
            containerRef.current?.getBoundingClientRect().left;

        if (containerTop && containerLeft) {
            const tooltipX = clientX - containerLeft + tooltipOffsetX;
            const tooltipY = clientY - containerTop + tooltipOffsetY;

            setTooltipPosition({ x: tooltipX, y: tooltipY });
        }
    };

    const handleMouseMove = (event: React.MouseEvent) => {
        handleMousePosition(event);
    };

    const handleMouseEnter = (event: React.MouseEvent) => {
        handleMousePosition(event);
        setTooltipVisible(true);
    };

    const handleMouseLeave = () => {
        setTooltipVisible(false);
    };

    return (
        <div
            onMouseMove={handleMouseMove}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            ref={containerRef}
            style={{
                cursor: "grab"
            }}
        >
            {isTooltipVisible && (
                <div
                    ref={tooltipRef}
                    style={{
                        position: "absolute",
                        top: tooltipPosition.y,
                        left: tooltipPosition.x,
                        zIndex: "5"
                    }}
                >
                    {content}
                </div>
            )}
            {children}
        </div>
    );
};

export default HeroTooltip;
